export const MY_ACCOUNT_VIEW_QUERY_PARAM = 'myAccountView';

export const getMyAccountViewParam = (search) => {
  return new URLSearchParams(search).get(MY_ACCOUNT_VIEW_QUERY_PARAM);
};

export const removeMyAccountViewParam = (search, fullUrl) => {
  const urlparams = new URLSearchParams(search);
  urlparams.delete(MY_ACCOUNT_VIEW_QUERY_PARAM);
  const queryStr = urlparams.toString();
  const rawUrl = fullUrl.split('?')[0];
  return `${rawUrl}${queryStr ? '?' + queryStr : ''}`;
};
